import type {
	LoginFlow,
	UpdateLoginFlowBody,
	UpdateLoginFlowWithPasswordMethod,
} from "@ory/kratos-client";
import type React from "react";
import { Link } from "react-router";
import {
	ContentContainer,
	ContentContainerWrapper,
} from "~/components/ContentContainer";
import { Flow } from "~/components/KratosFlow";
import { DefaultLayout } from "~/components/Layout";

interface Props {
	onSubmit: (values: UpdateLoginFlowBody) => Promise<void>;
	flow: LoginFlow;
}

/**
 * Password Login form
 *
 * Chrome の Autofill を有効化している場合は、見た目上、form に入力されているように見えても、
 * 実際はユーザのインタラクションがあるまでは実体化されない。
 * そのため、Reactの状態的には、値は空の状態になるため、一度適当な場所をクリックするまでSubmitできない。
 * アプリケーション的には、Autofill が有効化されていることは検知可能であるが、値の取得はできない。
 * @see https://stackoverflow.com/questions/55244590/autofill-does-not-trigger-onchange
 *
 * @param flow
 * @param onSubmit
 * @constructor
 */
export const PasswordLogin: React.FC<Props> = ({ flow, onSubmit }) => {
	return (
		<>
			<title>Login | TIER IV Account</title>
			<DefaultLayout>
				<ContentContainerWrapper>
					<ContentContainer>
						<Flow<UpdateLoginFlowWithPasswordMethod & { method: "password" }>
							onSubmit={onSubmit}
							flow={flow}
							context={{
								withIcon: true,
							}}
							nodeDisablers={[
								{
									target: { name: "method" },
									keys: ["identifier", "password"],
									/**
                   ログインフォームでは未入力バリデーションをしない

                   Chrome の Autofill を有効化している場合は、見た目上、form に入力されているように見えても、
                   実際はユーザのインタラクションがあるまでは実体化されない。
                   そのため、Reactの状態的には、値は空の状態になるため、一度適当な場所をクリックするまでSubmitできない。
                   アプリケーション的には、Autofill が有効化されていることは検知可能であるが、値の取得はできない。
                   @see https://stackoverflow.com/questions/55244590/autofill-does-not-trigger-onchange
                   */
									allowEmpty: true,
									allowNotChanged: true,
								},
							]}
						/>
						<div className="mt-6">
							<SignUpButton flow={flow} />
						</div>
						<p className="mt-6 text-center">
							<Link to="/recovery">
								Forgot password<span className="font-semibold">?</span>
							</Link>
						</p>
					</ContentContainer>
				</ContentContainerWrapper>
			</DefaultLayout>
		</>
	);
};

const SignUpButton: React.FC<{ flow: LoginFlow }> = ({ flow }) => {
	let registrationLink = "/registration";
	if (flow.return_to) {
		registrationLink += `?return_to=${flow.return_to}`;
	}
	return (
		<div className="w-full inline-block text-center">
			<a
				className="btn btn-lg-text btn-t4-border rounded-full"
				href={registrationLink}
			>
				SIGN UP
			</a>
		</div>
	);
};
